<template>
  <div v-loading.fullscreen.lock="loading">
    <entertain-client-search-bar-component
      add_auth="新增招待客户"
      @search="get_entertain_client_index"
      @addTeam="addTeam"
    ></entertain-client-search-bar-component>
    <common-table-component
      details_auth="招待客户详情"
      :col_arr="fcol_arr"
      :table_data="ftable_data"
      @details_row="details_entertain_client"
    ></common-table-component>
    <common-page-component
      :current_page="cond.page"
      :page_size="cond.limit"
      :total="ftotal"
      @search="get_entertain_client_index"
    ></common-page-component>
    <entertain-client-edit-component
      edit_auth="修改招待客户"
      del_auth="删除招待客户"
      :id="fid"
      :show_type="edit_type"
      :dialogFormVisible="fdialogFormVisible"
      :entertain_client_details_data="fentertain_client_details_data"
      @exitEntertainClientDialog="dialogExit"
      @search="get_entertain_client_index"
      @show_edit="show_edit"
      @details_row="details_entertain_client"
    ></entertain-client-edit-component>
  </div>
</template>

<script>
import {
  entertain_client_index_request,
  entertain_client_details_request,
} from "@/network/finance/EntertainClient.js";

import EntertainClientSearchBarComponent from "@/components/finance/EntertainClient/EntertainClientSearchBarComponent";
import CommonTableComponent from "@/components/common/CommonTableComponent";
import CommonPageComponent from "@/components/common/CommonPageComponent";
import EntertainClientEditComponent from "@/components/finance/EntertainClient/EntertainClientEditComponent";

export default {
  name: "EntertainClientView",
  data() {
    return {
      fid: 0,
      edit_type: 0,
      fdialogFormVisible: false,
      loading: false,
      ftotal: 0,
      cond: {
        name: "",
        page: 1,
        limit: 10,
      },
      ftable_data: [],
      fcol_arr: [
        {
          prop: "name",
          label: "客户名称",
          minWidth: "200px",
        },
        {
          prop: "create_staff_name",
          label: "创建人",
          minWidth: "80px",
        },
        {
          prop: "create_time",
          label: "创建时间",
          minWidth: "80px",
        }
      ],
      fentertain_client_details_data: {},
    };
  },
  computed: {},
  methods: {
    // 添加信息（弹框）
    addTeam() {
      this.edit_type = 1;
      this.fdialogFormVisible = true;
    },
    // 修改（弹框）
    show_edit() {
      this.edit_type = 2;
    },
    get_entertain_client_index(param = {}) {
      this.loading = true;
      this.cond.name = param.name ?? this.cond.name;
      this.cond.page = param.page ?? this.cond.page;
      if (param.limit) {
        this.cond.limit = param.limit;
        this.cond.page = 1;
      }
      entertain_client_index_request(this.cond)
        .then((s) => {
          this.loading = false;
          if (s.status === 0) {
            this.ftable_data = s.result.data;
            this.ftotal = s.result.total;
          } else {
            this.$message.error(s.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err);
        });
    },
    details_entertain_client(id) {
      this.fid = id;
      this.fdialogFormVisible = true;
      entertain_client_details_request(id)
        .then((s) => {
          if (s.status === 0) {
            this.fentertain_client_details_data = s.result;
          } else {
            this.$message.error(s.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    dialogExit() {
      this.fdialogFormVisible = false;
      this.fid = 0;
      this.edit_type = 0;
    },
  },
  filters: {},
  props: {},
  created() {
    this.get_entertain_client_index();
  },
  destoryed() {},
  mounted() {},
  updated() {},
  components: {
    EntertainClientSearchBarComponent,
    CommonTableComponent,
    CommonPageComponent,
    EntertainClientEditComponent,
  },
  watch: {},
};
</script>

<style lang="less"></style>
